import React from "react";
import { Box, Typography, createStyles, withStyles } from "@material-ui/core";
import { StepProgressContext } from "./StepProgressContext";
import { magicLinkColors } from "./magicLinkTokens";

interface Props {
  title: string;
  description?: string;
  classes: Record<string, string>;
}

const styles = (theme: any) =>
  createStyles({
    root: {
      display: "flex",
      flexDirection: "column",
      gap: 12
    },
    titleRow: {
      display: "flex",
      alignItems: "baseline",
      justifyContent: "space-between",
      gap: 12
    },
    title: {
      fontFamily: "Nunito Sans",
      fontSize: "24px",
      fontWeight: 600,
      lineHeight: "33px",
      color: magicLinkColors.textStrong
    },
    counter: {
      fontFamily: "Nunito Sans",
      fontSize: "14px",
      fontWeight: 600,
      lineHeight: "20px",
      color: magicLinkColors.textMuted,
      whiteSpace: "nowrap"
    },
    line: {
      height: 1,
      backgroundColor: theme.palette.primary.main
    },
    description: {
      fontFamily: "Nunito Sans",
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "20px",
      color: magicLinkColors.text
    }
  });

const StepHeader = ({ title, description, classes }: Props) => {
  const progress = React.useContext(StepProgressContext);
  return (
    <Box className={classes.root}>
      <Box className={classes.titleRow}>
        <Typography component="h1" className={classes.title}>
          {title}
        </Typography>
        {progress && (
          <Typography className={classes.counter}>
            Step: {progress.current} of {progress.total}
          </Typography>
        )}
      </Box>
      <Box className={classes.line} />
      {description && (
        <Typography className={classes.description}>{description}</Typography>
      )}
    </Box>
  );
};

export default withStyles(styles)(StepHeader);
